import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <Loader2 className="w-6 h-6 animate-spin text-primary" />
    </div>
  );
}

export function ProtectedRoute({ children }) {
  const { user, checked } = useAuth();
  if (!checked) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export function AdminRoute({ children }) {
  const { user, checked } = useAuth();
  if (!checked) return <Loading />;
  if (!user || user.role !== "admin") return <Navigate to="/admin/login" replace />;
  return children;
}
